import { SettingsState } from "../states/uiStates";
import { RegionV5 } from "../types/riot";
import { getFromStorage, setStorage } from "../utils";

export function storeSettings(settings: SettingsState) {
	setStorage("settings", settings);
}

export function loadSettings() {
	return getFromStorage("settings", {}) as SettingsState;
}

export function storeLastSearch(name: string, region: RegionV5) {
	setStorage("last_search_2", { name, region });
}

export function loadLastSearch() {
	return getFromStorage("last_search_2", {}) as { name: string; region: RegionV5 };
}
